export const en = {
    'nav.today': "Today's Overview",
    'nav.calendar': "Demand Calendar",
    'nav.rates': "Rates & Rules",
    'nav.automation': "Automation Center",
    'nav.audit': "Audit Log",
    'nav.settings': "Settings",
    'sidebar.status': "Connected",
    'stat.occupancy': "Occupancy",
    'stat.adr': "ADR",
    'stat.revpar': "RevPAR",
    'stat.revenue': "Est. Revenue",
    'stat.trend.vsLastWeek': "vs Lwk",
    'stat.trend.onPace': "On pace",
    'dashboard.actions.title': "Recommended Actions",
    'dashboard.actions.empty': "No actions found.",
    'filter.all': "All",
    'filter.pricing': "Pricing",
    'filter.restriction': "Restrictions",
    'action.approve': "Approve & Push",
    'action.reject': "Reject",
    'action.risk.low': "low risk",
    'action.risk.medium': "medium risk",
    'action.risk.high': "high risk",
    'action.label.current': "Current",
    'action.label.proposed': "Proposed",
    'action.metric.impact': "Impact",
    'action.metric.why': "Why",
    'action.status.executed': "Auto-Executed",
    'header.search': "Type to search...",
    'header.logout': "Logout",
    'auto.level.title': "Autopilot Level",
    'auto.level.manual': "Manual",
    'auto.level.manual.desc': "You approve every single recommendation.",
    'auto.level.assisted': "Assisted",
    'auto.level.assisted.desc': "Auto-approve low risk changes. Review major moves.",
    'auto.level.auto': "Fully Automatic",
    'auto.level.auto.desc': "The AI runs pricing 24/7 within your guardrails.",
    'auto.level.active': "Active",
    'auto.guardrails.title': "Safety Guardrails",
    'auto.guardrails.maxIncrease': "Max Daily Increase",
    'auto.guardrails.maxIncrease.desc': "Prevent price shocks for guests.",
    'auto.guardrails.maxDecrease': "Max Daily Decrease",
    'auto.guardrails.maxDecrease.desc': "Prevent accidental dumping.",
    'auto.guardrails.minRate': "Hard Floor Rate",
    'auto.guardrails.minRate.desc': "Never sell below this price (Net).",
    'auto.emergency.title': "Emergency Override",
    'auto.emergency.label': "Emergency Stop",
    'auto.emergency.desc': "Immediately pause all automation.",
    'auto.emergency.btn': "PAUSE SYSTEM",
    'rates.filter.all': "All Room Types",
    'rates.filter.next14': "Next 14 Days",
    'rates.export': "Export",
    'audit.table.time': "Time",
    'audit.table.actor': "Actor",
    'audit.table.category': "Category",
    'audit.table.action': "Action",
    'audit.table.details': "Details",
    'audit.table.status': "Status",
    'settings.pms.title': "PMS Connection",
    'settings.pms.connected': "Connected to",
    'settings.pms.disconnect': "Disconnect",
    'settings.account.title': "Account",
    'settings.account.role': "Role",
    'settings.restart': "Restart Onboarding",
    'onboard.title': "Connect your PMS",
    'onboard.desc': "Select your Property Management System to sync inventory.",
    'onboard.connecting': "Connecting...",
    'onboard.connect': "Connect",
    'onboard.success.title': "Setup Complete!",
    'onboard.success.desc': "Your hotel **SynthHotel Berlin** is now synced.",
    'onboard.success.sub': "Imported 3 Room Types, 14 Rate Plans, and 243 Future Bookings.",
    'onboard.btn.dashboard': "Go to Dashboard",
    'action.dynamic.weekend.title': "Increase Rate for High Demand Weekend",
    'action.dynamic.weekend.desc': "Occupancy crossed 75% for Saturday, pickup is strong (+12 rooms in 24h).",
    'action.dynamic.minstay.title': "Enable 2-Night Min Stay",
    'action.dynamic.minstay.desc': "Taylor Swift concert announced. Prevent 1-night stays blocking inventory.",
    'action.dynamic.distress.title': "Lower Rate (Distress)",
    'action.dynamic.distress.desc': "Occupancy is 35% for next Tuesday. Competitors dropped by €10.",
    'action.dynamic.gap.title': "Gap Fill: Remove CTA",
    'action.dynamic.gap.desc': "Single night gap found. Remove Close To Arrival to sell the room.",
};
